export const TRANSLATIONS_FR = {
  "routes_Pages": "Pages",
  "routes_Dashboard": "Tableau de bord",
  "routes_Questionnaire": "Normes",
  "routes_Stats": "Statistiques",
  "routes_Settings": "Paramètres",
  "routes_Resouces": "Ressources",
  "routes_Contact": "Contact",
  "routes_Downloads": "Téléchargements",
  "routes_Documentation": "Documentation",
  "dashboard_welcome_message": "Bienvenue dans le tableau de bord du système de gestion de l'accessibilité 👋",
  "dashboard_label": "Toutes vos données d'accessibilité rassemblées, structurées et surveillées en un seul endroit.",
  "gettingStartedCard_gettingStarted": "Commencer",
  "gettingStartedCard_gettinStartedDescription": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam elementum dui nunc, ac porta sem consequat nec. Pellentesque",
  "gettingStartedCard_Steps": "Nous recommandons ces étapes pour commencer :",
  "gettingStartedCard_step1": "Lire la documentation",
  "gettingStartedCard_step2": "Téléchargez la liste de contrôle",
  "gettingStartedCard_step3": "Vérifiez vos statistiques",
  "companyCard_supportedStandards": "Normes prises en charge :",
  "companyCard_companyInformation": "Informations sur la société",
  "companyCard_numberOfEmployees": "employés",
  "propertyListPage_propertyList": "Liste des propriétés",
  "propertyListPage_dashboard": "Tableau de bord",
  "propertyListPage_Questionnaire": "Normes",
  "propertyListPage_newProperty": "Nouvelle propriété",
  "propertyListPage_textmapEdit": "Modifier la propriété",
  "propertyListPage_textmapQuestionnaire": "Classer",
  "propertyListPage_textmapFacility": "Modifier l'établissement",
  "propertyListPage_textmapNewProperty": "Nouvelle propriété",
  "propertyListPage_createNewProperty": "Créer une nouvelle propriété",
  "propertyListPage_disabilityClassification": "Classification du handicap",
  "propertyListPage_editProperty": "Modifier la propriété",
  "propertyListPage_editFacilities": "Modifier les installations",
  "propertyListPage_classify": "Classer",
  "propertyListPage_search": "Rechercher par nom de propriété",
  "propertyForm_propertyInformation": "1.1 Informations sur la propriété",
  "propertyForm_standardType": "Modèle standard",
  "propertyForm_fieldCannotBeChanged": "Ce champ ne peut pas être modifié",
  "propertyForm_propertyCategory": "Catégorie de propriété",
  "propertyForm_typeOfProperty": "Type de propriété",
  "propertyForm_propertyName": "Nom de la propriété",
  "propertyForm_propertyArea": "Quantité de mètres carrés de surface au sol",
  "propertyForm_enterPropertyAddress": "1.1.2 Saisir l'adresse de la propriété",
  "propertyForm_addressLocation": "Tapez l'adresse ci-dessous",
  "propertyForm_mapNote": "Si nécessaire, vous pouvez ajuster la carte pour que l'épingle soit au bon endroit",
  "propertyForm_keyPropertyData": "1.2 Données clés sur les propriétés",
  "propertyForm_floorsQuestion": "Combien d'étages votre propriété a-t-elle ?",
  "propertyForm_roomsQuestion": "De combien de pièces votre propriété dispose-t-elle ?",
  "propertyForm_disabledRoomsQuestion": "De combien de chambres pour personnes handicapées votre établissement dispose-t-il ?",
  "propertyForm_alergyRoomsQuestion": "De combien de salles d’allergie votre établissement dispose-t-il ?",
  "propertyForm_save": "Sauvegarder",
  "propertyForm_propertyHotelTypeOptionsLabel_Hotel": "Hôtel",
  "propertyForm_propertyHotelTypeOptionsLabel_Motel": "Motel",
  "propertyForm_propertyConvenienceStoreOptions_Candies": "Des sucreries",
  "propertyForm_propertyConvenienceStoreOptions_Newspapers": "Journaux",
  "propertyForm_propertyConvenienceStoreOptions_TobaccoProducts": "Produits du tabac",
  "propertyForm_propertyConvenienceStoreOptions_Toiletries": "Articles de toilette",
  "propertyForm_propertyConvenienceStoreOptions_Store": "Magasin",
  "propertyForm_propertyConvenienceStoreOptions_Supermarket": "Supermarché",
  "propertyForm_propertyDepartmentStoreOptions_Clothing": "Vêtements",
  "propertyForm_propertyDepartmentStoreOptions_DepartmentStore": "Department_store",
  "propertyForm_propertyDepartmentStoreOptions_Electronics": "Électronique",
  "propertyForm_propertyDepartmentStoreOptions_Garden": "Jardin",
  "propertyForm_propertyDepartmentStoreOptions_Household_goods": "Articles_ménagers",
  "propertyForm_propertyDepartmentStoreOptions_Pets": "Animaux domestiques",
  "propertyForm_propertyDepartmentStoreOptions_Toys": "Jouets",
  "propertyForm_propertyFoodAndDrinkOptions_bakery_and_baked_goods_store": "Boulangerie et magasin de pâtisserie",
  "propertyForm_propertyFoodAndDrinkOptions_dairy_goods": "Produits laitiers",
  "propertyForm_propertyFoodAndDrinkOptions_food_and_drink": "Nourriture et boisson",
  "propertyForm_propertyFoodAndDrinkOptions_food_beverage_specialty_store": "Magasin spécialisé en boissons alimentaires",
  "propertyForm_propertyFoodAndDrinkOptions_grocery": "Épicerie",
  "propertyForm_propertyFoodAndDrinkOptions_meat": "Viande",
  "propertyForm_propertyFoodAndDrinkOptions_specialty_food_store": "Magasin d'alimentation spécialisé",
  "propertyForm_propertyFoodAndDrinkOptions_Vegan": "Végétalien",
  "propertyForm_propertyFoodAndDrinkOptions_Vegetarian": "Végétarien",
  "propertyForm_propertyFoodAndDrinkOptions_wine_and_liquor": "Vin et liqueur",
  "propertyForm_propertyDrugstoreOptions_drugstore": "Pharmacie",
  "propertyForm_propertyDrugstoreOptions_pharmacy": "Pharmacie",
  "propertyForm_propertyElectronicsOptions_computer_and_software": "Ordinateur et logiciels",
  "propertyForm_propertyElectronicsOptions_consumer_electronics_store": "Magasin d'électronique grand public",
  "propertyForm_propertyElectronicsOptions_electronics": "Électronique",
  "propertyForm_propertyElectronicsOptions_entertainment_electronics": "Divertissement_électronique",
  "propertyForm_propertyElectronicsOptions_mobile_retailer": "Détaillant mobile",
  "propertyForm_propertyElectronicsOptions_mobile_service_center": "Centre de services mobiles",
  "propertyForm_propertyMallOptions_shopping_gallery_mall": "Galerie marchande",
  "propertyForm_propertyMallOptions_shopping_mall": "Centre commercial",
  "propertyForm_standardTypeOptions_hotel_motel": "Hôtel/Motel",
  "propertyForm_standardTypeOptions_shopping_mall": "Centre commercial",
  "propertyForm_standardTypeOptions_shop": "Boutique",
  "propertyForm_propertyHardwareOptions_floor_and_carpet": "Sol et moquette",
  "propertyForm_propertyHardwareOptions_furniture_store": "Magasin de meubles",
  "propertyForm_propertyHardwareOptions_garden_center": "Jardinerie",
  "propertyForm_propertyHardwareOptions_glass_and_window": "Verre et fenêtre",
  "propertyForm_propertyHardwareOptions_hardware_house_garden": "Jardin de quincaillerie",
  "propertyForm_propertyHardwareOptions_home_improvement_hardware_store": "Quincaillerie de rénovation domiciliaire",
  "propertyForm_propertyHardwareOptions_home_specialty_store": "Magasin spécialisé pour la maison",
  "propertyForm_propertyHardwareOptions_lumber": "Bois de sciage",
  "propertyForm_propertyHardwareOptions_major_appliance": "Gros électroménager",
  "propertyForm_propertyHardwareOptions_paint_store": "Magasin de peinture",
  "propertyForm_propertyHardwareOptions_power_equipment_dealer": "Concessionnaire d'équipements électriques",
  "propertyForm_propertyBookstoreOptions_bookstore": "Librairie",
  "propertyForm_propertyClothingOptions_childrens_apparel": "Vêtements pour enfants",
  "propertyForm_propertyClothingOptions_clothing_and_accessories": "Vêtements et accessoires",
  "propertyForm_propertyClothingOptions_mens_apparel": "Vêtements pour hommes",
  "propertyForm_propertyClothingOptions_shoes_footwear": "Chaussures chaussures",
  "propertyForm_propertyClothingOptions_specialty_clothing_store": "Magasin de vêtements spécialisés",
  "propertyForm_propertyClothingOptions_womens_apparel": "Vêtements pour femmes",
  "propertyForm_consumerGoodsOptions_adult_shop": "Boutique pour adultes",
  "propertyForm_consumerGoodsOptions_arts_and_crafts_supplies": "Fournitures d'art et d'artisanat",
  "propertyForm_consumerGoodsOptions_bicycle_and_bicycle_accessories_shop": "Magasin de vélos et d'accessoires pour vélos",
  "propertyForm_consumerGoodsOptions_camping_hiking_shop": "Boutique camping randonnée",
  "propertyForm_consumerGoodsOptions_canoe_kayak_shop": "Boutique de canoë-kayak",
  "propertyForm_consumerGoodsOptions_car_accessories": "Accessoires de voiture",
  "propertyForm_consumerGoodsOptions_consumer_goods": "Biens de consommation",
  "propertyForm_consumerGoodsOptions_cross_country_ski_shop": "Magasin de ski de fond",
  "propertyForm_consumerGoodsOptions_florist": "Fleuriste",
  "propertyForm_consumerGoodsOptions_general_merchandise": "Marchandise générale",
  "propertyForm_consumerGoodsOptions_gift_antique_art": "Cadeau d'art ancien",
  "propertyForm_consumerGoodsOptions_hobby_store": "Magasin de loisirs",
  "propertyForm_consumerGoodsOptions_hunting_fishing_shop": "Magasin de chasse et pêche",
  "propertyForm_consumerGoodsOptions_jeweler": "Bijoutier",
  "propertyForm_consumerGoodsOptions_market": "Marché",
  "propertyForm_consumerGoodsOptions_motorcycle_accessories": "Accessoires moto",
  "propertyForm_consumerGoodsOptions_non_store_retailers": "Détaillants hors magasin",
  "propertyForm_consumerGoodsOptions_office_supply_store": "Magasin de fournitures de bureau",
  "propertyForm_consumerGoodsOptions_pawnshop": "Prêteur sur gage",
  "propertyForm_consumerGoodsOptions_pet_supply": "Fourniture pour animaux de compagnie",
  "propertyForm_consumerGoodsOptions_record_cd_video": "Enregistrer une vidéo sur CD",
  "propertyForm_consumerGoodsOptions_running_walking_shop": "Boutique de course à pied",
  "propertyForm_consumerGoodsOptions_skate_shop": "Magasin de skate",
  "propertyForm_consumerGoodsOptions_ski_snowboard_shop": "Magasin de ski et de snowboard",
  "propertyForm_consumerGoodsOptions_specialty_store": "Boutique sécialisée",
  "propertyForm_consumerGoodsOptions_sporting_goods_store": "Magasin d'articles de sport",
  "propertyForm_consumerGoodsOptions_surf_shop": "Magasin de surf",
  "propertyForm_consumerGoodsOptions_tack_shop": "Boutique d'armurerie",
  "propertyForm_consumerGoodsOptions_toy_store": "Magasin de jouets",
  "propertyForm_consumerGoodsOptions_used_second_hand_merchandise_stores": "Magasins de brocantes d'occasion",
  "propertyForm_consumerGoodsOptions_variety_store": "Magasin de variétés",
  "propertyForm_consumerGoodsOptions_video_and_game_rental": "Location de vidéos et de jeux",
  "propertyForm_consumerGoodsOptions_warehouse_wholesale_store": "Magasin de gros en entrepôt",
  "propertyForm_hairAndBeautyOptions_barber": "Coiffeur",
  "propertyForm_hairAndBeautyOptions_hair_and_beauty": "Cheveux et beauté",
  "propertyForm_hairAndBeautyOptions_hair_salon": "Salon de coiffure",
  "propertyForm_hairAndBeautyOptions_nail_salon": "Salon de manucure",
  "propertyForm_hairAndBeautyOptions_make_up_salon": "Salon de maquillage",
  "propertyForm_mallTopCategoryOptions_mall_shopping_complex": "Complexe commercial du centre commercial",
  "propertyForm_accomodationsCategoryOptions_hotel_motel": "Hôtel/Motel",
  "propertyForm_shopCategoryOptions_convenience_store": "Épicerie",
  "propertyForm_shopCategoryOptions_department_store": "Grand magasin",
  "propertyForm_shopCategoryOptions_food_and_drink": "Nourriture et boisson",
  "propertyForm_shopCategoryOptions_drugstore_or_pharmacy": "Pharmacie ou pharmacie",
  "propertyForm_shopCategoryOptions_electronics": "Électronique",
  "propertyForm_shopCategoryOptions_hardware_house_garden": "Jardin de quincaillerie",
  "propertyForm_shopCategoryOptions_bookstore": "Librairie",
  "propertyForm_shopCategoryOptions_clothing_and_accessories": "Vêtements et accessoires",
  "propertyForm_shopCategoryOptions_consumer_goods": "Biens de consommation",
  "propertyForm_shopCategoryOptions_hair_and_beauty": "Cheveux et beauté",
  "facilitiesForm_standardTypeOptions_hotel_motel": "Hôtel/Motel",
  "facilitiesForm_standardTypeOptions_office": "Bureau",
  "facilitiesForm_standardTypeOptions_shopping_mall": "Centre commercial",
  "facilitiesForm_standardTypeOptions_shop": "Boutique",
  "facilitiesForm_selectFacilitiesForDataCollection": "2. Sélectionnez les installations pour la collecte de données",
  "facilitiesForm_preselectedMandatoryItems": "Les éléments présélectionnés suivants sont obligatoires",
  "facilitiesForm_mandatoryFacilitiesFor": "Installations obligatoires pour",
  "facilitiesForm_optionalFacilitiesFor": "Installations facultatives pour",
  "facilitiesForm_standard": "Standard",
  "facilitiesForm_preselectedOptionalItems": "Les éléments suivants sont facultatifs",
  "facilitiesForm_faq_mandatoryFacilities": "Quelles sont les installations obligatoires ?",
  "facilitiesForm_faq_AnswerMandatoryFacilities": "Ce sont des équipements standards que l’on retrouve dans les propriétés de votre genre. Pour générer nos données d’accessibilité de manière approfondie, ces installations doivent être évaluées. EX l'entrée du bâtiment",
  "facilitiesForm_faq_optionalFacilities": "Quelles sont les installations optionnelles ?",
  "facilitiesForm_faq_AnswerOptionalFacilities": "Il s'agit d'une liste non exhaustive d'équipements qui peuvent exister ou non dans votre propriété, mais qui ne sont pas nécessairement des équipements standards dans une propriété comme la vôtre. Par exemple, un Spa dans un hôtel ou dans un centre commercial.",
  "unitForm_helperText_entrance_key": "Entrée",
  "unitForm_helperText_entrance_value": "c'est-à-dire l'entrée principale ou les entrées secondaires telles que via le restaurant ou les jardins",
  "unitForm_helperText_lobby_key": "Hall d'entrée",
  "unitForm_helperText_lobby_value": "c'est-à-dire hall principal de la propriété comprenant un salon ou une zone d'attente",
  "unitForm_helperText_reception_key": "Accueil/bureau d'information",
  "unitForm_helperText_reception_value": "c'est-à-dire bureau d'enregistrement principal, bureau de conciergerie, zone de stockage des bagages ou zones de bureau d'information",
  "unitForm_helperText_facility_key": "Facilité",
  "unitForm_helperText_facility_value": "",
  "unitForm_helperText_parking_key": "Parking et alentours proches",
  "unitForm_helperText_parking_value": "c'est-à-dire une zone de stationnement principale et des zones extérieures supplémentaires telles que des jardins, des allées, des allées",
  "unitForm_helperText_commonAreas_key": "Espaces communs",
  "unitForm_helperText_commonAreas_value": "Espaces publics partagés de l'hôtel tels que le salon du hall, les couloirs, etc.",
  "unitForm_helperText_conferenceRoom_key": "Salle de conférence / salle de réunion",
  "unitForm_helperText_conferenceRoom_value": "",
  "unitForm_helperText_auditorium_key": "Salle",
  "unitForm_helperText_auditorium_value": "Espace de style théâtre, cinéma, etc.",
  "unitForm_helperText_diningArea_key": "Salle à manger",
  "unitForm_helperText_diningArea_value": "Par exemple, restaurant principal, espace buffet de petit-déjeuner, bar/bistro du hall.",
  "unitForm_helperText_toiletRoom_key": "Salle de toilettes (commune, partagée)",
  "unitForm_helperText_toiletRoom_value": "c'est-à-dire toilettes/salle de bains communes accessibles depuis le hall, le restaurant ou d'autres espaces publics.",
  "unitForm_helperText_gym_key": "Salle de sport",
  "unitForm_helperText_gym_value": "",
  "unitForm_helperText_spa_key": "Spa",
  "unitForm_helperText_spa_value": "",
  "unitForm_helperText_hospitalityRoom_key": "Type de chambre d'hospitalité",
  "unitForm_helperText_hospitalityRoom_value": "c'est-à-dire le type de chambre, par exemple simple, double, accessible, familiale, etc.",
  "unitForm_quantityLabel": "Sélectionnez la quantité",
  "unitForm_locationFaq": "Où est-il situé?",
  "unitForm_totalQuantity": "Quantité totale",
  "unitForm_floorSelection": "Sélectionnez l'étage",
  "unitForm_finishedCreation": "Avez-vous fini de créer des unités ?",
  "unitForm_startClassifying": "Questionnaire!",
  "unitForm_unitData2": "Toilettes Privées",
  "unitForm_unitData3": "Salle de bains privée",
  "unitForm_unitData4": "Cuisine privée",
  "unitForm_unitTypeDetails": "3. Détails du type d'unité :",
  "unitForm_unitName": "Écrivez ici le nom de votre unité",
  "unitForm_accessibleUnit": "Cette unité est considérée comme accessible",
  "questionUnits_addNewUnit": "Ajouter une nouvelle unité",
  "questionUnits_savedInfo": "Vos informations ont été enregistrées",
  "questionUnits_removedInfo": "Vos informations ont été supprimées",
  "questionUnits_resources": "Ressources",
  "questionUnits_uploadPictures": "Télécharger des photos",
  "questionUnits_explanation": "Quelques explications/détails sur cette section peuvent aller ici",
  "questionUnits_uploadLabel": "TÉLÉCHARGER",
  "questionUnits_unitExtraInfo": "Informations supplémentaires sur l'unité",
  "questionUnits_unitExtraInfoPlaceholder1": "Ici, vous pouvez insérer des commentaires privés sur cette unité spécifique",
  "questionUnits_unitExtraInfoPlaceholder2": "(actuellement vous n'avez aucun commentaire sur cet appareil)",
  "questionUnits_beforeClassification": "Vous devez ajouter des installations avant de commencer à classer",
  "questionUnits_editFacilities": "Modifier les installations",
  "questionUnits_addNew": "Cliquez sur « Ajouter un nouveau » ou sélectionnez l'unité pour commencer la classification.",
  "questionUnits_faq1": "Info",
  "questionUnits_faq2": "Quelles sont les installations obligatoires ?",
  "questionUnits_faq2_1": "Ce sont des équipements standards que l’on retrouve dans les propriétés de votre genre. Pour générer nos données d’accessibilité de manière approfondie, ces installations doivent être évaluées. EX l'entrée du bâtiment",
  "questionUnits_faq3": "Quelles sont les installations optionnelles ?",
  "questionUnits_faq3_1": "Il s'agit d'une liste non exhaustive d'équipements qui peuvent exister ou non dans votre propriété, mais qui ne sont pas nécessairement des équipements standards dans une propriété comme la vôtre. Par exemple, un Spa dans un hôtel ou dans un centre commercial.",
  "FAR_SelectProperty": "Sélectionnez une propriété",
  "FAR_DocumentPreview": "Aperçu du document :",
  "FAR_DownloadPDF": "Télécharger le PDF:",
  "FAR_Download": "Télécharger maintenant!",
  "CLP_SelectProperty": "Sélectionnez une propriété",
  "CLP_SelectPropertyForChecklist": "Sélectionnez une propriété pour créer la liste de contrôle",
  "CLP_AccessibilityChecklist": "Liste de contrôle d'accessibilité",
  "CLP_GeneratedOn": "Généré le",
  "CLP_GeneratedBy": "Généré par",
  "CLP_LoadingDoc": "Chargement du document...",
  "CLP_DownloadNow": "Télécharger maintenant!",
  "A11yUnitsPageSubTitle": "Choses à garder à l'esprit",
  "A11yUnitsPageDescription": "Vous ne pouvez associer des unités similaires que si elles sont exactement identiques. Sinon, un autre type d'unité doit être créé.",
  "routes_NewProperty": "Nouvelle propriété",
  "routes_EditProperty": "Modifier la propriété",
  "routes_EditFacility": "Modifier l'installation",
  "routes_SelectFacilities": "Sélectionnez les installations",
  "routes_CreateProperty": "Créer une propriété",
  "routes_Classify": "Classer",
  "routes_Blank": "Vide",
  "changePassword_success": "Succès",
  "changePassword_successMessage": "Votre mot de passe a été mis à jour",
  "changePassword_returnToLogin": "Revenir à la connexion",
  "changePassword_resetPassword": "Réinitialisez votre mot de passe",
  "changePassword_newPassword_label": "nouveau mot de passe",
  "changePassword_confirmNewPassword_label": "Confirmer le nouveau mot de passe",
  "changePassword_newPasswordRequired_errorMessage": "Un nouveau mot de passe est requis",
  "changePassword_newPasswordMismatch_errorMessage": "Les mots de passe doivent correspondre",
  "changePassword_newPassword_browserTab": "Changer le mot de passe",
  "DocumentationPage_pageTitle": "Page de documentation",
  "DocumentationPage_tabtitle": "Documentation",
  "DownloadsPage_pageTitle": "Page de téléchargements",
  "LanguagesDropdown_English": "Anglais",
  "LanguagesDropdown_French": "Français",
  "LanguagesDropdown_German": "Allemand",
  "LanguagesDropdown_Dutch": "Néerlandais",
  "LocationAutocomplete_searchPlaceholder": "Rechercher des lieux...",
  "LocationAutocomplete_validAddress": "Veuillez indiquer le numéro de la maison et la rue",
  "LocationAutocomplete_addressEmpty": "L'adresse ne peut pas être vide",
  "page404_PageNotFound": "Page non trouvée.",
  "page404_PageNotFound_explanation": "La page que vous recherchez a peut-être été supprimée.",
  "page404_PageNotFound_returnHome_button": "Retour au site Web",
  "page500_InternalError": "Erreur interne du serveur.",
  "page500_InternalError_explanation": "Le serveur n'est pas prêt à s'occuper de la salope qui a commencé.",
  "propertyListPage_NotClassified": "Non classés",
  "propertyListIconName_allergy_food_class": "Classe alimentaire contre les allergies",
  "propertyListIconName_allergy_room_class": "Cours de salle d'allergie",
  "propertyListIconName_mobility_class": "Classe de mobilité",
  "propertyListIconName_hearing_class": "Cours d'audition",
  "propertyListIconName_cognitive_class": "Classe cognitive",
  "propertyListIconName_visual_class": "Classe visuelle",
  "propertyForm_AllStepsCompleted": "Toutes les étapes terminées",
  "propertyForm_propertyReady": "Votre propriété est maintenant prête !",
  "propertyForm_propertyReady_description": "Vous avez terminé l'étape d'information sur votre propriété. Vous pouvez modifier ces informations en cliquant sur le lien Liste des propriétés dans le panneau supérieur gauche.",
  "propertyForm_startClassifying": "COMMENCER LA CLASSIFICATION",
  "propertyForm_propertyStepper_step1": "Ajouter des informations sur la propriété",
  "propertyForm_propertyStepper_step2": "Sélectionnez les installations",
  "propertyForm_propertyStepper_step3": "Ajouter des détails sur l'unité",
  "settingsForms_CompanyInformation_SelectOptions_Service": "Service",
  "settingsForms_CompanyInformation_SelectOptions_Merchandising": "Marchandisage",
  "settingsForms_CompanyInformation_SelectOptions_Manufacturing": "Fabrication",
  "settingsForms_CompanyInformation_SelectOptions_Other": "Autre",
  "settingsForms_ImageCantBeChanged": "Cette image ne peut pas être modifiée",
  "settingsForms_RegNumber_label": "Numéro d'enregistrement",
  "settingsForms_InvoiceStatus_label": "Statut de la facture",
  "settingsForms_CompanyName_label": "Nom de l'entreprise",
  "settingsForms_CompanyType_label": "Type de compagnie",
  "settingsForms_CompanySize_label": "Taille de l'entreprise",
  "settingsForms_CompanyAddress_label": "Adresse de la société",
  "settingsForms_ContractDate_label": "Date de signature du contrat",
  "settingsForms_SubscriptionPeriod_label": "Période d'abonnement",
  "settingsForms_Employees_label": "Employés",
  "settingsForms_UserInformation_positionOptions_owner": "Propriétaire",
  "settingsForms_UserInformation_positionOptions_executive": "Exécutif",
  "settingsForms_UserInformation_positionOptions_manager": "Directeur",
  "settingsForms_UserInformation_positionOptions_operations_and_production": "Opérations et production",
  "settingsForms_UserInformation_positionOptions_other": "Autre",
  "settingsForms_UserInformation_departmentOptions_it": "IL",
  "settingsForms_UserInformation_departmentOptions_marketing": "Commercialisation",
  "settingsForms_UserInformation_departmentOptions_finance": "Finance",
  "settingsForms_UserInformation_departmentOptions_human_resources": "Ressources humaines",
  "settingsForms_UserInformation_departmentOptions_sales": "Ventes",
  "settingsForms_UserInformation_departmentOptions_operations": "Opérations",
  "settingsForms_UserInformation_departmentOptions_other": "Autre",
  "settingsForms_UserInformation_title": "informations de l'utilisateur",
  "settingsForms_UserInformation_UploadPicture": "Charger une photo",
  "settingsForms_UserInformation_formatRestriction": "Utilisez une image d'au moins 128 px sur 128 px au format .jpg",
  "settingsForms_UserInformation_surname": "Nom de famille",
  "settingsForms_UserInformation_position": "Position",
  "settingsForms_UserInformation_department": "Département",
  "settingsPage_pageTitle": "Page Paramètres",
  "settingsPage_breadcrumbs_dashboard": "Tableau de bord",
  "settingsPage_breadcrumbs_settings": "Paramètres",
  "signinForm_explanation": "Connectez-vous à votre compte pour continuer",
  "signinForm_validEmail_error": "Doit être un e-mail valide",
  "signinForm_emailRequired": "L'e-mail est requis",
  "signinForm_generalError": "Quelque chose s'est mal passé",
  "signinForm_passwordRequired": "Mot de passe requis",
  "signinForm_emailLabel_textfield": "Adresse e-mail",
  "signinForm_passwordLabel_textfield": "Mot de passe",
  "signinForm_remberMeCheckbox_textfield": "Souviens-toi de moi",
  "signinForm_signIn_button": "Se connecter",
  "signinForm_forgotPassword_button": "Mot de passe oublié",
  "signupForm_signUp_button": "S'inscrire",
  "signupForm_signUp_title": "Commencer",
  "signupForm_signUp_subTitle": "Commencez à créer la meilleure expérience utilisateur possible pour vos clients",
  "signupForm_signUp_nameRequired": "Le nom est requis",
  "signupForm_signUp_minCharacters_errorMessage": "Doit contenir au moins 12 caractères",
  "signupForm_signUp_required_errorMessage": "Requis",
  "signupForm_signUp_nameLabel": "Nom",
  "signupForm_signUp_companyLabel": "Entreprise",
  "signupForm_signUp_emailAddressLabel": "Adresse e-mail",
  "signupForm_signUp_passwordLabel": "Mot de passe",
  "signupForm_signUp_confirmPasswordLabel": "Confirmez le mot de passe",
  "statsPage_pageTitle": "Page de statistiques",
  "statsPage_cardContent": "Cette page sera disponible dans les futures versions du système de gestion de l'accessibilité.",
  "resetPassword_inbox": "Vérifiez votre boîte de réception",
  "resetPassword_explanation_1": "Nous avons envoyé un e-mail à",
  "resetPassword_explanation_2": "avec instructions de restauration du mot de passe",
  "resetPassword_title": "réinitialiser le mot de passe",
  "resetPassword_subTitle": "Entrez votre e-mail pour réinitialiser votre mot de passe",
  "unitForm_title": "Unités composites",
  "unitForm_floorTitle": "Sol",
  "unitImagesDialog_labelMANDATORY": "OBLIGATOIRE",
  "unitImagesDialog_labelOPTIONAL": "FACULTATIF",
  "unitImagesDialog_labelPICTURES": "DES PHOTOS",
  "unitImagesDialog_dropzone": "Déposez des photos ici ou choisissez un fichier",
  "userDropdown_profile": "Profil",
  "userDropdown_signout": "se déconnecter",
  "questionUnits_uploadPictures_uploadError": "Une erreur s'est produite lors du téléchargement des photos",
  "questionUnits_uploadSuccess": "Vos données ont été soumises avec succès",
  "questionUnits_unitExtraInfoLabel": "Informaitons supplémentaires",
  "questionUnits_unitExtraInfoDelete_button": "Supprimer",
  "questionUnits_unitExtraInfoSave_button": "Sauvegarder",
  "QuestionnaireCompletionCard_title": "Achèvement des normes",
  "QuestionnaireCompletionCard_disableMessage": "Vous n'avez pas encore de classement.",
  "QuestionnaireCompletionCard_ParkingCard": "Parking",
  "QuestionnaireCompletionCard_EntranceCard": "Entrée",
  "QuestionnaireCompletionCard_ToiletCard": "Toilettes",
  "QuestionnaireCompletionCard_RoomsCard": "Pièces",
  "QuestionnaireCompletionCard_LiftAndElevatorsCard": "Ascenseur et ascenseurs",
  "QuestionnaireCompletionCard_LobbyAndReceptionCard": "Hall d'entrée et réception",
  "FAR_Report": "Rapport sur l'accessibilité",
  "FAR_TableUnitName": "Nom de l'unité",
  "FAR_TableDescription": "Description",
  "CLP_PleaseSelectProperty": "Veuillez sélectionner la propriété",
  "CLP_BrowserTabTitle": "Rapport complet sur l'accessibilité",
  "CLP_UnitMandatoryLabel": "Obligatoire",
  "CLP_UnitDoneLabel": "FAIT",
  "propertyPage_Controllers_SearchDoc": "Rechercher des documents",
  "generalWords_Yes": "Oui",
  "generalWords_No": "Non",
  "generalWords_Next": "Suivant",
  "generalWords_Close": "Fermer",
  "generalWords_Reset": "Réinitialiser",
  "generalWords_Back": "Dos",
  "generalWords_Finish": "Finition",
  "generalWords_NextStep": "L'étape suivante",
  "generalWords_Edit": "Modifier",
  "generalWords_Download": "Télécharger",
  "generalWords_Delete": "Supprimer",
  "generalWords_SaveChanges": "Sauvegarder les modifications",
  "generalWords_Selected": "choisi",
  "generalWords_Required": "Requis",
  "customerSupportPage_title": "Page d'assistance client",
  "customerSupportPage_emailLabel": "Contactez le service client à :",
  "unitForm_helperText_entrance": "c'est-à-dire l'entrée principale ou les entrées secondaires telles que via le restaurant ou les jardins.",
  "unitForm_helperText_lobby": "c'est-à-dire Hall principal de la propriété comprenant un salon ou une zone d'attente.",
  "unitForm_helperText_reception": "c'est-à-dire le bureau d'enregistrement principal, le bureau de conciergerie, la zone de stockage des bagages ou les zones de bureau d'information.",
  "unitForm_helperText_facility": "c'est-à-dire le nom de l'installation ou de la propriété.",
  "unitForm_helperText_parking": "c'est-à-dire une zone de stationnement principale et des zones extérieures supplémentaires telles que des jardins, des allées et des allées.",
  "unitForm_helperText_conferenceRoom": "Une salle de conférence est une grande pièce où plusieurs personnes peuvent tenir une conférence.",
  "unitForm_helperText_auditorium": "Espace de style théâtre, cinéma, etc.",
  "unitForm_helperText_diningArea": "Par exemple, restaurant principal, espace buffet de petit-déjeuner, bar/bistro du hall.",
  "unitForm_helperText_toiletRoom": "c'est-à-dire toilettes/salle de bains communes accessibles depuis le hall, le restaurant ou d'autres espaces publics.",
  "unitForm_helperText_gym": "Exercices et activités physiques effectués à l’intérieur, souvent à l’aide d’équipements.",
  "unitForm_helperText_spa": "Endroit où l'on peut se détendre grâce à un sauna, une piscine et un jacuzzi.",
  "unitForm_helperText_hospitalityRoom": "c'est-à-dire le type de chambre, par exemple simple, double, accessible, familiale, etc.",
  "unitForm_helperText_shopping_aisle": "c'est-à-dire une allée entre les étagères.",
  "unitForm_helperText_counter": "Une surface plane (telle qu'une table, une étagère ou une vitrine) sur laquelle les transactions sont effectuées.",
  "unitForm_helperText_checkout_pay": "Par exemple, paiement, paiement automatique, paiement par auto-analyse.",
  "unitForm_helperText_fitting_room": "Pièce d'un magasin dans laquelle les clients peuvent enfiler un vêtement pour voir s'il lui va avant de l'acheter.",
  "unitForm_helperText_manned_kiosk": "Un terminal de change ou de remboursement d'espèces, qui permet d'effectuer des transactions en espèces et sans numéraire avec un caissier.",
  "unitForm_helperText_floor": "c'est-à-dire l'accessibilité à différents niveaux tels que l'ascenseur au 1er étage, l'ascenseur vert à l'entrée 2.",
  "unitForm_helperText_playground": "Une zone utilisée par les enfants pour jouer. Ils disposent généralement d'équipements tels que des toboggans, des balançoires et des balançoires sur lesquels les enfants peuvent jouer.",
  "unitForm_helperText_garden": "Espace, généralement extérieur, réservé à la culture, à l’exposition et à l’appréciation des plantes et d’autres formes de nature.",
  "unitForm_helperText_bathroom_common": "Une pièce contenant une baignoire ou une douche et généralement un lavabo et des toilettes.",
  "unitForm_helperText_bathroom__private": "Une pièce privée contenant une baignoire ou une douche et généralement un lavabo et des toilettes.",
  "unitForm_helperText_quiet_room": "Une pièce calme ou pièce silencieuse est une pièce construite en ce qui concerne le silence en protégeant le bruit de ou vers l'environnement.",
  "unitForm_helperText_kitchen_common": "Une salle publique où l'on peut préparer et cuisiner de la nourriture.",
  "unitForm_helperText_toilet_room__private": "c'est-à-dire des toilettes privées accessibles depuis le hall, le restaurant ou d'autres espaces publics.",
  "unitForm_helperText_kitchen__private": "Une salle privée où l'on peut préparer et cuisiner des plats.",
  "unitForm_helperText_conferenceRoom_": "",
  "routes_Services": "Prestations de service",
  "routes_Help": "Aide",
  "routes_Clp": "Liste de contrôle",
  "routes_Far": "Rapport sur l'accessibilité",
  "FAR_WhatIsItTitle": "Qu'est-ce qu'un rapport d'accessibilité ?",
  "FAR_WhatIsItDescription": "Le rapport d'accessibilité est un rapport que nous générons pour vous en fonction de l'accessibilité de votre propriété. Ci-dessous, vous pouvez sélectionner une propriété et télécharger son rapport PDF.",
  "FAR_MoreInfo": "Pour plus d’informations sur le rapport sur l’accessibilité, veuillez",
  "FAR_SelectPropertyForChecklist": "Sélectionnez une propriété pour créer le rapport",
  "CLP_noChecklistFound": "Nous n'avons pas trouvé de liste pour cette propriété",
  "CLP_WhatIsItTitle": "Qu'est-ce qu'une liste de contrôle ?",
  "CLP_WhatIsItDescription": "La liste de contrôle est une liste basée sur les informations d'inventaire du système d'accessibilité. Il montre les domaines à améliorer, en fonction de votre contribution au système. Un aperçu du document est disponible et peut être téléchargé ou imprimé.",
  "CLP_MoreInfo": "Pour plus d'informations sur la liste de contrôle, veuillez",
  "CLP_FAR_ConsultTheDocumentation": "consulter la documentation",
  "LanguagesDropdown_Swedish": "suédois",
  "LanguagesDropdown_Danish": "danois",
  "gettingStartedCard_step1_link": "Lire",
  "gettingStartedCard_step2_link": "Télécharger",
  "gettingStartedCard_step3_link": "Vérifier",
  "contactForm_category": "Catégorie",
  "contactForm_title": "Contactez-nous",
  "contactForm_chooseImg": "Choisir une image",
  "contactForm_submitBtn": "Envoyer une demande",
  "contactForm_attachBtnLabel": "Si possible, veuillez joindre une capture d'écran.",
  "contactForm_messageLabel": "Veuillez décrire votre demande ici.",
  "contactForm_messageEmptyError": "Veuillez ajouter un message",
  "contactForm_categoryOptions_ServiceInquiry": "Demande de service",
  "contactForm_categoryOptions_TechnicalIssues": "Problèmes techniques",
  "contactForm_categoryOptions_OtherInquires": "Autres demandes",
  "contactForm_subtitle1": "Si vous ne trouvez pas la réponse que vous cherchez, nous sommes là pour vous donner un coup de main.",
  "contactForm_subtitle2": "S'il vous plaît écrivez-nous! Nous vous répondrons dans les plus brefs délais.",
  "FAR_noDataAvalible_1": "Le rapport sur l'accessibilité ne peut pas encore être généré pour cette propriété. Veuillez compléter le",
  "FAR_noDataAvalible_2": "pour",
  "FAR_noDataAvalible_3": "d'abord.",
  "CLP_Updating": "Mise à jour...",
  "CLP_AreYouSure": "Es-tu sûr?",
  "CLP_UpdateMessage": "Si vous procédez ainsi, l'élément disparaîtra de la liste de contrôle et la norme sera automatiquement mise à jour pour refléter le changement.",
  "CLP_Cancel": "ANNULER",
  "CLP_YesUpdate": "OUI, MISE À JOUR",
  "CLP_WhatIsAChecklist": "Qu'est-ce qu'une liste de contrôle ?",
  "CLP_Name": "Nom",
  "CLP_pdfDisclaimer": "Remarque : Une fois les améliorations apportées, n'oubliez pas de mettre à jour vos données d'accessibilité dans la section standard.",
  "CLP_FAR_noAccessibilityDataAvailable1": "Nous ne disposons d'aucune donnée d'accessibilité disponible.",
  "CLP_noChecklist1": "La liste de contrôle ne peut pas encore être générée pour cette propriété. Répondez aux questions à l'intérieur du",
  "CLP_noChecklist2": "section standard",
  "CLP_noChecklist3": "pour",
  "CLP_noChecklist4": "d'abord.",
  "CLP_FAR_noAccessibilityDataAvailable2": "Créer une propriété",
  "CLP_FAR_noAccessibilityDataAvailable3": "et répondez d'abord aux questions de la section standard.",
  "statsPage_subscriptionExpiring": "Abonnement expirant dans",
  "statsPage_days": "jours",
  "statsPage_contactCustomerSupport": "Contactez l'assistance clientèle",
  "statsPage_companyInformation": "Informations sur la société",
  "statsPage_numberOfPhotosUploaded": "Nombre de photos téléchargées",
  "statsPage_photos": "Photos",
  "statsPage_totalAmountProperties": "Montant total des propriétés",
  "statsPage_amountCompleted": "Montant complété",
  "statsPage_actionsPerVisitor": "Actions par visiteur sur le Widget",
  "statsPage_yourItems": "Vos articles",
  "statsPage_name": "Nom",
  "statsPage_sku": "UGS",
  "statsPage_quantity": "Quantité",
  "statsPage_numberOfUnits": "Nombre d'unités",
  "statsPage_accessible": "Accessible",
  "statsPage_notAccessible": "Pas accessible",
  "statsPage_unit": "Unité",
  "statsPage_amount": "Montant",
  "statsPage_incomplete": "Incomplet",
  "statsPage_completed": "Complété",
  "statsPage_notCompleted": "Pas achevé",
  "statsPage_mobility": "Mobilité",
  "statsPage_cognitive": "Cognitif",
  "statsPage_hearing": "Audience",
  "statsPage_visual": "Visuel",
  "statsPage_allergy": "Allergie",
  "statsPage_class": "Classe",
  "statsPage_totalAccessibilityDatapoints": "Points de données d’accessibilité totale",
  "statsPage_visitorsThatOpened": "Visiteurs ayant ouvert le widget",
  "statsPage_visitorsInteraction": "Total des actions sur le widget",
  "statsPage_action": "Action",
  "statsPage_clicks": "Clics",
  "statsPage_noDataAvailable_topText": "Il n'y a pas de données disponibles",
  "statsPage_noDataAvailable_bottomText": "À l'heure actuelle",
  "statsPage_company_address": "Adresse",
  "statsPage_company_city": "Ville",
  "statsPage_company_country": "Pays",
  "statsPage_company_name": "Nom",
  "statsPage_company_type": "Taper",
  "statsPage_company_registration_number": "Numéro d'enregistrement",
  "statsPage_company_logo": "Logo",
  "statsPage_company_employees": "Employés",
  "statsPage_company_empty_fields": "Champs vides",
  "settingsPage_alertMsgImageUpload": "Cliquez sur Enregistrer pour mettre à jour votre photo de profil",
  "settingsPage_alertMsgCompanyInformation_1": "Contact",
  "settingsPage_alertMsgCompanyInformation_2": "Service client",
  "settingsPage_alertMsgCompanyInformation_3": "si vous devez apporter des modifications aux informations sur l'entreprise.",
  "documentationPage_downloadDocument": "Télécharger le document",
  "documentationPage_loadingDocument": "Chargement du document",
  "CLP_Status": "Statut",
  "CLP_lastUpdate": "Dernière mise à jour",
  "CLP_completed": "complété",
  "CLP_incomplete": "incomplet",
  "LanguagesDropdown_Languages": "Langues",
  "login_welcome_message": "Bienvenue dans le système de gestion de l'accessibilité 👋",
  "CLP_Checklist_is_generated_based": "La liste de contrôle est générée sur la base des données d'accessibilité que nous collectons auprès de votre propriété. Il montre les domaines d'amélioration et une fois que vous avez coché le point, la réponse est automatiquement mise à jour dans le système et vos données d'accessibilité seront modifiées. Le document peut être téléchargé pour un usage externe. Pour plus d'informations",
  "CLP_Go_to_checklist": "Aller à la liste de contrôle",
  "CLP_Updated_date": "Date mise à jour",
  "CLP_The_purpose_of_Handiscover_1": "Le but de l'inventaire et de la liste de contrôle de Handiscover est de vous guider dans l'amélioration de votre accessibilité. La liste ci-jointe comprend plusieurs éléments. Du point de vue que quelque chose doit être adapté à l’accessibilité, certains points sont obligatoires. De plus, nous identifions les points tels que nous recommandons s'il faut construire du neuf ou rénover.",
  "CLP_List_points": "Liste des points",
  "CLP_Priority": "Priorité",
  "CLP_User": "Utilisateur",
  "CLP_Mandatory": "Obligatoire",
  "CLP_Need_help": "Besoin d'aide? Contactez notre équipe",
  "CLP_Handiscovers_suggestions": "Les suggestions de Handiscover",
  "propertyForm_nextStep_tooltip": "Remplissez d'abord tous les champs obligatoires",
  "statsPage_See_photos": "Voir les photos",
  "statsPage_Your_subscription": "Votre abonnement",
  "statsPage_Filter_data_from": "Filtrer les données de",
  "statsPage_Filter_data_to": "Filtrer les données pour",
  "statsPage_to": "à",
  "statsPage_Reload": "Recharger",
  "statsPage_Business_Metrics": "Mesures commerciales",
  "statsPage_Service_Metrics": "Métriques de service",
  "statsPage_Statistics_page": "Page de statistiques",
  "imagesPage_Pictures_List": "Liste des photos",
  "imagesPage_Search_by_name": "Rechercher par nom",
  "imagesPage_No_pictures_available": "Aucune photo disponible",
  "imagesPage_Name": "Nom",
  "imagesPage_Display_in_widget": "Afficher dans le widget",
  "imagesPage_Type": "Taper",
  "imagesPage_Update_date": "Date de mise à jour",
  "imagesPage_Mandatory": "Obligatoire",
  "imagesPage_Are_your_sure": "Etes-vous sûr ?",
  "imagesPage_Delete": "Supprimer",
  "imagesPage_Yes": "Oui",
  "imagesPage_Cancel": "Annuler",
  "imagesPage_Open_image": "Ouvrir l'image",
  "imagesPage_Edit": "Modifier",
  "imagesPage_Delete_image": "Supprimer l'image",
  "CLP_The_purpose_of_Handiscover_2": "Nous avons également inclus des points « faciles » à corriger mais probablement importants du point de vue de l'accessibilité.",
  "a11yUnits_The_title_has_been_translated": "Le titre a été traduit",
  "statsPage_Statistics": "Statistiques",
  "customerSupportPage_thankYou": "Merci!",
  "customerSupportPage_requestSuccessfully": "Votre demande a été envoyée avec succès. Notre service client prendra en charge votre demande et vous répondra dans les plus brefs délais.",
  "customerSupportPage_warning": "Avertissement",
  "customerSupportPage_error": "Erreur",
  "propertyListPage_showAll": "Afficher tout",
  "propertyListPage_completed": "Complété",
  "propertyListPage_incomplete": "Incomplet",
  "dashboard": "Tableau de bord",
  "widget": "Widget",
  "property_type": "Type de propriété",
  "category": "Catégorie",
  "edit_widget": "Modifier le widget",
  "created": "Créé",
  "published": "Publié",
  "unpublished": "Inédit",
  "widget_info": "Le widget d'accessibilité affiche les données d'accessibilité détaillées précédemment enregistrées dans le système de gestion de l'accessibilité. Ce widget permet de créer de meilleures conditions permettant aux visiteurs de planifier leur séjour à l'avance en voyant l'accessibilité disponible. Le widget d'accessibilité est interactif car toutes les données mises à jour dans le système sont lues dans le widget.",
  "view_live_widget": "Afficher le widget en direct",
  "no_widget_data_message": "Nous n'avons pas de données de widget. Veuillez contacter notre service client.",
  "image_list": "Liste d'images",
  "language_setting": "Paramètres de langue",
  "history": "Histoire",
  "select_accessibility_unit": "Sélectionnez l'unité d'accessibilité",
  "add_new_image": "Ajouter une nouvelle image",
  "order": "Commande",
  "image": "Image",
  "description": "Description",
  "accessibility_unit": "Unité d'accessibilité",
  "accessibility": "Accessibilité",
  "displayed_in_widget": "Affiché dans le widget",
  "current_image": "Image actuelle",
  "upload_new_picture": "Télécharger une nouvelle photo",
  "image_description": "description de l'image",
  "image_order": "Ordre des images",
  "back_to_list": "Retour à la liste",
  "no_picture": "Pas d'image",
  "please_write_the_text_in": "Veuillez écrire le texte en",
  "yes_delete": "OUI, SUPPRIMER",
  "delete_warning_text": "Si vous faites cela, l'élément disparaîtra du widget et la norme sera automatiquement mise à jour pour refléter le changement.",
  "select_language_the_widget_provide": "Sélectionnez la langue fournie par le widget",
  "changed_by": "Changé par",
  "activity": "Activité",
  "showing": "Affichage",
  "of": "de",
  "items": "articles",
  "questionnaire": "Questionnaire",
  "we_are_showing_followings": "Nous montrons les éléments suivants dans votre widget",
  "we_are_recommended_to_state": "Il est recommandé de préciser quelques informations pratiques dans le Widget destiné aux visiteurs de votre bien. Si vous souhaitez le modifier, veuillez contacter notre service client",
  "select_what_you_want_to_show": "Sélectionnez ce que vous souhaitez afficher dans le widget",
  "practical_information": "Informations pratiques",
  "you_can_add_maximum": "Vous pouvez ajouter maximum 3 phrases",
  "for_the_best_experiences_in_widget": "Pour les meilleures expériences dans Widget, nous vous aiderons si vous souhaitez ajouter plus d'informations",
  "if_you_do_this_the_item_will_disappear": "Si vous faites cela, l'élément disparaîtra du widget",
  "you_can_write_free_texts": "Vous pouvez rédiger des textes libres pour compléter les informations générales si besoin. 40 caractères maximum",
  "write_a_new_information": "Écrivez une nouvelle information",
  "you_can_drag_and_drop_the_block": "Vous pouvez glisser et déposer le bloc pour modifier les commandes. Veuillez cocher la case à présenter dans le widget.",
  "you_can_freely_change_the_images_ordering": "Vous pouvez librement modifier l’ordre des images par glisser-déposer.",
  "preview": "Aperçu",
  "add_point_on_map": "Ajouter un point sur la carte",
  "LanguagesDropdown_Spanish": "Espagnol",
  "LanguagesDropdown_Norwegian": "Norvégien",
  "LanguagesDropdown_Portuguese": "Portugais",
  "LanguagesDropdown_Ukrainian": "Ukrainien",
  "main_unit_image": "Image(s) de l'unité principale",
  "item_pictures": "Images de l'article",
  "please_choose_a_main_unit_image": "Veuillez choisir une image de l'unité principale",
  "please_choose_a_item_picture": "Veuillez choisir une image de l'article",
  "button_settings_updated": "Les paramètres du bouton ont été mis à jour avec succès",
  "button_settings_created": "Les paramètres du bouton ont été créés avec succès",
  "button_settings": "Paramètres des boutons",
  "webmaster_instruction": "Instruction pour les webmasters",
  "contract_has_expired": "Votre contrat a expiré. Le widget a été suspendu. Contacter le support",
  "webmaster_instructions_are_not_available": "Les instructions pour les webmasters ne sont pas disponibles pour le moment. Contacter le support",
  "create_api_key": "Créer une clé API pour cette entreprise",
  "standard_instruction": "Instruction standard",
  "google_tag_manager_instruction": "Instructions relatives à Google Tag Manager"
}